import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProcessoAbas } from '../../../models/processo-abas.model';
import { ProcessoAbasService } from '../../../services/processo-abas.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';

@Component({
  selector: 'app-abas-list',
  templateUrl: './abas-list.component.html',
  styleUrls: ['./abas-list.component.scss'],
})
export class AbasListComponent
  extends BaseListComponent<ProcessoAbas>
  implements OnInit, OnDestroy
{
  idProcesso: any;
  abasList: ProcessoAbas[];
  canSave: boolean = false;
  ordenacao: boolean;

  constructor(
    private myService: ProcessoAbasService,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private navigation: NavigationService,
  ) {
    super();
  }

  ngOnInit() {
    let currentUrl = this.router.url;
    const regex = /processos\/(\d+)\/abas/;
    const match = currentUrl.match(regex);

    if (match) {
      this.idProcesso = match[1];
      this.initLoadDataTable();
    } else {
      console.log('ID não encontrado');
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getListAll(this.idProcesso).subscribe((res) => {
        this.abasList = res['list'];
        this.canSave = res['canSave'];
        this.loaded();
      })
    );
  }

  novo() {
    return ['adicionar'];
  }

  editar(id: number) {
    return ['/pre-projeto/processos/abas', id];
  }

  salvarOrdem() {
    this.loading();
    this.ordenacao = false;

    this.addSub(
      this.myService.salvarOrdem(this.getDataCreateOrder()).subscribe({
        next: (res) => {
          this.msgSuccess('Ordem Salva com Sucesso!');
          this.loaded();
        },
        error: (err) => {
          this.msgError(err?.error?.message);
          this.loaded();
        },
      })
    );
  }

  drop(event: CdkDragDrop<string[]>) {
    this.ordenacao = true;
    moveItemInArray(this.abasList, event.previousIndex, event.currentIndex);
    this.abasList.forEach((item, index) => {
      item.nro_ord = index + 1;
    });
  }

  getDataCreateOrder(): any {
    return {
      aba_ordem: this.abasList.map((item) => {
        return { id: item.id, nro_ord: item.nro_ord };
      }),
    };
  }

  voltar() {
    this.navigation.back(['/pre-projeto', 'processos']);
  }
}
